import type { StaticImageData } from "next/image";
import Image from "next/image";
import Link from "next/link";
import type { ReactNode } from "react";

import { cn } from "../../../lib/utils";
import { NavigationMenuLink } from "../../ui/navigation-menu";

export const FeatureNavListItem = ({
  path,
  src,
  label,
  subtitle,
  disabled,
  className,
}: {
  path: string;
  src: StaticImageData;
  label: string;
  subtitle?: string | ReactNode;
  disabled?: boolean;
  className?: string;
}) => {
  return (
    <li className="row-span-3 mr-2">
      <NavigationMenuLink asChild>
        <Link
          href={path}
          aria-disabled={disabled}
          onClick={(e) => {
            if (disabled) {
              e.preventDefault();
            }
          }}
          className={cn(disabled && "pointer-events-none opacity-40", className)}
        >
          <div className="group relative flex h-full w-full select-none flex-col justify-end p-3 outline-none focus:shadow-md">
            {/* Backdrop */}
            <div className="absolute left-0 top-0 hidden h-full w-full overflow-hidden lg:block">
              <div className="absolute left-0 top-0 h-4/5 w-full gradient-mask-b-50">
                <Image
                  priority={true}
                  placeholder="blur"
                  fill={true}
                  className={
                    "object-cover object-[center_22%] transition-all duration-100 gradient-mask-b-30 group-hover:scale-[1.02]"
                  }
                  alt=""
                  src={src}
                />
              </div>
              <div
                className="absolute h-full w-full "
                style={{
                  backgroundImage:
                    "linear-gradient(to top, rgb(0,0,0, 1) 0%, rgba(0,0,0, 0.8) 15%, rgba(0,0,0, 0.6) 25%, transparent 45%)",
                }}
              />
            </div>

            {/* content */}
            <div className="z-[1] transition-opacity duration-300 group-hover:opacity-40">
              <div className={"mb-0.5 font-title font-bold leading-none"}>{label}</div>
              {subtitle && (
                <p className="line-clamp-2 font-title font-medium leading-none opacity-75">
                  {subtitle}
                </p>
              )}
            </div>
          </div>
        </Link>
      </NavigationMenuLink>
    </li>
  );
};
